var classes = {"overlayMenuItem":"PPy7I"};

export { classes as default };
